var f = Object.defineProperty, i = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var a = (o, e, r) => e in o ? f(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    p.call(e, r) && a(o, r, e[r]);
  if (t)
    for (var r of t(e))
      s.call(e, r) && a(o, r, e[r]);
  return o;
}, c = (o, e) => i(o, n(e));
import g, { forwardRef as h } from "react";
import B from "../lib/IconBase.mjs";
import d from "../defs/BehanceLogo.mjs";
const l = h((o, e) => /* @__PURE__ */ g.createElement(B, c(m({ ref: e }, o), { weights: d })));
l.displayName = "BehanceLogo";
export {
  l as BehanceLogo
};
